/** All money operates in USD for now (see CLAUDE.md, rule 9). */
export const DEFAULT_CURRENCY = 'USD';

/** Timestamps are stored in UTC and displayed in the tenant's time zone. */
export const DEFAULT_TIMEZONE = 'America/El_Salvador';
